import { makeStyles  } from '@mui/styles';
import { createTheme , ThemeProvider  } from '@mui/material';
/* https://www.cnbc.com/  */

// ORIGINALLY LQ export const theme = createTheme(({
//   palette: {
//     primary: {
//       light: '#72f6ff',
//       main: '#21c3fd',
//       dark: '#0093ca',
//       contrastText: '#fff',
//     },
//     secondary: {
//       light: '#fff8ff',
//       main: 'FF8500',
//       dark: '#cb94af',
//       contrastText: '#000',
//     },
//   },
// }));

export const theme = createTheme(({
    palette: {
      primary: {
        light: '#3FC8FC',
        main: '#037AA7',
        dark: '#02506C',
        contrastText: '#fff',
      },
      secondary: {
        light: '#FFB35E',
        main: '#FF8500',
        dark: '#BB6200',
        contrastText: '#000',
      },
    },
  }));

  export const Tp_themeProvider=ThemeProvider;

  export const __makeStyles=makeStyles;